import { cn } from '@/lib/utils';

interface CountBadgeProps {
  count: number;
  className?: string;
}

export const CountBadge = ({ count, className }: CountBadgeProps) => {
  if (count <= 0) return null;
  return (
    <span
      className={cn(
        'absolute flex h-3.5 min-w-[14px] items-center justify-center rounded-full bg-emerald-600 px-1 text-[9px] font-medium text-white',
        className,
      )}
    >
      {count}
    </span>
  );
};
